export const EDUCATION_TYPES = Object.freeze({
  CONTRACT: 'Контракт',
  QUOTA: 'Квота',
  NETWORK: 'Сетевые программы',
});

export const EDUCATION_TYPE_LIST = [EDUCATION_TYPES.CONTRACT, EDUCATION_TYPES.QUOTA, EDUCATION_TYPES.NETWORK];

// Раздел карточки в URL. Сетевые программы открываются той же карточкой, что и контракт,
// но по своему адресу. Неизвестный тип по старой логике ведёт в квоту.
const CARD_SECTION = {
  [EDUCATION_TYPES.CONTRACT]: 'contract',
  [EDUCATION_TYPES.QUOTA]: 'quota',
  [EDUCATION_TYPES.NETWORK]: 'network',
};

export const studentCardPath = (educationType, id) =>
  `/${CARD_SECTION[educationType] || CARD_SECTION[EDUCATION_TYPES.QUOTA]}/${id}`;
